const AssignedDepartmentIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#E2C7FC" />
      <path
        d="M15.9998 12.2499C15.9998 13.8608 14.694 15.1666 13.0832 15.1666C11.4723 15.1666 10.1665 13.8608 10.1665 12.2499C10.1665 10.6391 11.4723 9.33325 13.0832 9.33325C14.694 9.33325 15.9998 10.6391 15.9998 12.2499Z"
        stroke="#820BF4"
        stroke-width="1.25"
      />
      <path
        d="M17.25 15.1666C18.8608 15.1666 20.1667 13.8608 20.1667 12.2499C20.1667 10.6391 18.8608 9.33325 17.25 9.33325"
        stroke="#820BF4"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M16.9523 22.6667H9.21412C8.3594 22.6667 7.6665 22.0272 7.6665 21.2382C7.6665 19.2657 9.39874 17.6667 11.5356 17.6667H14.6308C15.5018 17.6667 16.3056 17.9324 16.9523 18.3807"
        stroke="#820BF4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.8335 17.6667V22.6667M24.3335 20.1667H19.3335"
        stroke="#820BF4"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default AssignedDepartmentIcon;
